import React, { Component } from 'react';
import {  BarChart, Bar, Brush, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip as ReTooltip, Legend,ResponsiveContainer
} from 'recharts';
import { formatMoney } from '../lib/util';

var _month = new Array();
_month[0] = "Jan";
_month[1] = "Feb";
_month[2] = "Mar";
_month[3] = "Apr";
_month[4] = "May";
_month[5] = "Jun";
_month[6] = "Jul";
_month[7] = "Aug";
_month[8] = "Sep";
_month[9] = "Oct";
_month[10] = "Nov";
_month[11] = "Dec";


const renderQuarterTick = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value, offset } = payload;
    const date = new Date(value);
    const month = date.getMonth();
    const day=date.getUTCDate();
    // console.log("month is ",month,payload);

    if(day===10){
    return <text x={x + offset} y={y - 4} textAnchor="middle">{`${_month[month]}`}</text>
    }

    // if (month % 3 === 1) {
    //   return <text x={x + offset} y={y - 4} textAnchor="middle">{`Q${month}`}</text>;
    // }
  
    // const isLast = month === 11;
  
    // if (month % 3 === 0 || isLast) {
    //   const pathX = Math.floor(isLast ? x + offset * 2 : x) + 0.5;
  
    //   return <path d={`M${pathX},${y - 4}v${-35}`} stroke="red" />;
    // }
    // return null;
  };


class ReconciledYearBar extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
         list_data:this.props.data||[]
      };
    };
    
  render() {
      const {list_data}=this.state
    return (
        <ResponsiveContainer width='100%' height={400}>
        <BarChart
        data={list_data}
        margin={{
        top: 5, right: 30, left: 20, bottom: 5,
        }}
    >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis name="Date" dataKey="day" tick={()=>null} />
        <XAxis dataKey="day" axisLine={false} tickLine={false} interval={0} tick={renderQuarterTick} height={20} scale="band" xAxisId="quarter" />

        <YAxis />
        <ReTooltip formatter={(value,name,entry)=>{
                    // console.log("VALUE,",value,name);
                    let payload=entry.payload||{};

                    return <div>
                      <div>Transactions: {payload.count}</div>
                      <div>Amount:{formatMoney(payload.amount)}</div>
                    </div>
                  }} />
        <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} />
        <ReferenceLine y={0} stroke="#000" />
        {/* <Brush onChange={(props)=>{
        }} dataKey="day" height={30} stroke="#8884d8" /> */}
        <Bar name="Reconciled Status" dataKey="count" fill="#8884d8" />
        {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
        </BarChart>
        </ResponsiveContainer>
    );
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.data != prevProps.data) {
        this.setState({
            list_data: this.props.data,
        })
        // fetch the new product based and set it to the state of the component
    };
};
}

export default ReconciledYearBar;
